<div class="snackbar-container">
  <span class="snackbar-message">
    <ng-container #messageContainer>{{ message }}</ng-container>
  </span>
  <mat-icon svgIcon="ds-ic-close"
    class="snackbar-icon-close mat-icon-size-xs"
    (click)="onCloseClick()"></mat-icon>
</div>
